import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { SpouseFinancialSupportDescription } from '../../../../components/FormDescriptions';
import content from '../../../../locales/en/content.json';
import { strWithYear } from '../../../../utils/helpers';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['household-info--spouse-support-title'];
const INPUT_LABEL = strWithYear(
  content['household-info--spouse-support-label'],
);

const { provideSupportLastYear } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, SpouseFinancialSupportDescription),
    provideSupportLastYear: yesNoUI(INPUT_LABEL),
  },
  schema: {
    type: 'object',
    properties: { provideSupportLastYear },
  },
};
